import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import CookieValue from "../../../utils/cookie_value";
import Cookies from "universal-cookie";
import FetchResource from "../../../utils/fetch_resource";
import ApiCall from "../../../utils/api_call";
import LogIf from "../../../utils/log_if";
import TextInput from "../../TextInput";
import Datepicker from "../../Datepicker";
import Invitees from "./Invitees";
import EventSyllabi from "./EventSyllabi";
import InviteableList from "./InviteableList";
import { disable } from "debug";
import { options } from "colorette";
import { select } from "async";

const api_base = process.env.API_URL;
const client_base = process.env.BASE_URL;

/**
 * Both MATCH_KEY and ADDED_KEY are added as properties of
 * objects in the this.state.users array.
 * ADDED_KEY is also used as a property for items in this.state.syllabi.
 **/
const MATCH_KEY = "matches_search_params";
const ADDED_KEY = "added_to_event_form";

/**
 * DESTROY_KEY can be added (and set equal to 1) for nested
 * children of the parent Event that the user wishes to destroy.
 * e.g., inviteeElem[DESTROY_KEY] = 1 indicates that the users_event
 *       for the invitee should be destroyed (where inviteeElem is an
 *       object in this.state.invitees).
 **/
const DESTROY_KEY = "_destroy";
const DESTROY_VAL = 1;

/**Mirrored in the rails Event::STATUS_STATUSNAME consts**/
const EVENT_STATUS_SCHEDULED = "SCHEDULED";
const EVENT_STATUS_RESCHEDULED = "RESCHEDULED";
const EVENT_STATUS_CANCELED = "CANCELED";

export default class EventShowMainContainer extends Component {
  constructor(props) {
    super(props);
    let searchArr = this.props.location.search
      .substr(1)
      .split("&")
      .map((s) => s.split("="));
    let search = Object.fromEntries(searchArr.map(([k, v]) => [k, v]));
    this.state = {
      id: props.match.params.eventId || "new",
      summary: "",
      description: "",
      start_time: null,
      start_time_valid: true,
      end_time: null,
      end_time_valid: true,
      status: "",
      active: true,
      rrule: null,
      meeting_number: "",
      meeting_link: "",
      created_by: null,
      currentUserRole: props.currentUserRole,
      permissions: {},
      syl_events: [],
      syllabi: [],
      syllabi_selection: "",
      invitees: [],
      universities: [],
      universities_selection: "",
      selecting_invitees: false,
      send_invitations_on_update: false,
      users: [],
      events_categories: [],
      data_ready: false,
      notice_message: search["notice"]
        ? decodeURIComponent(search["notice"])
        : "",
      display_notice: !!search["notice"],
      display_error: false,
      can_update: false,
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.fetchEvent()
      .then(() => {
        this.setState({ data_ready: true });
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          const cookies = new Cookies();
          cookies.remove("user_auth");
          this.props.history.push("/log_in");
        } else {
          this.setState({ display_error: true });
        }
      });
    this.fetchSyllabi();
    this.fetchUsers();
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this._isMounted) {
      LogIf("debug", "called componentDidUpdate");
      /** no longer used? I think this was replaced with getting "permissions" from the API **/
      if (this.props !== prevProps) {
        this.setState({ currentUserRole: this.props.currentUserRole });
      }
      if (this.state.send_invitations_on_update === true) {
        LogIf("debug", "in send_invitations_on_update === true block");
        this.inviteAttendees();
      }
    }
  };

  fetchEvent = () => {
    return FetchResource(api_base + "events/" + this.state.id, "", this);
  };

  fetchSyllabi = () => {
    const url = api_base + "syllabi/";
    const reqOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
    };
    ApiCall(url, reqOptions, this)
      .then((data) => {
        this.setState({ syllabi: data["syllabi"] });
      })
      .catch((err) => {});
  };

  fetchUsers = () => {
    let { syllabi_selection, universities_selection } = this.state;
    let url = api_base + "users?";
    if (syllabi_selection.length > 0) {
      url += "user[syllabi][id]=" + syllabi_selection + "&";
    }
    if (universities_selection.length > 0) {
      url += "lookup_table[id]=" + universities_selection;
    }
    const reqOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
    };
    ApiCall(url, reqOptions, this)
      .then((data) => {
        LogIf("debug", "users data");
        LogIf("debug", data["users"]);
        this.unpackFilteredUsers(data["users"]);
      })
      .catch((err) => {});
  };

  /**
   * Update this.state.users with data from an API response, without
   * unintentionally overwriting the state ('invited',
   * 'matches_filter', etc.) of users already in the list.
   * @param users An array of users data, including email, full_name, and id
   **/
  unpackFilteredUsers = (filteredUsers) => {
    LogIf("debug", "unpackedFilteredUsers");
    let state = this.state;
    let { users } = state;
    const usersIndexMap = this.mapIndexByKeysValue(users, "id");
    console.log(usersIndexMap);
    for (let user of users) {
      delete user[MATCH_KEY];
    }
    for (let user of filteredUsers) {
      console.log("user id" + user.id.toString());
      let stateIndex = usersIndexMap[user.id];
      if (stateIndex != null) {
        users[stateIndex][MATCH_KEY] = true;
      } else {
        user[MATCH_KEY] = true;
        users.push(user);
      }
      console.log("should have match key:");
      console.log(user);
    }
    this.setState(state);
  };

  childAttributes = (children, assoc_id_key) => {
    let ret = [];
    children.forEach((child) => {
      //null is abstractly equivalent to undefined
      if (child.id != null && child._destroy != null) {
        ret.push({
          id: child.id,
          _destroy: child._destroy,
        });
      } else if (child.id == null && child._destroy != 1) {
        let h = {};
        h[assoc_id_key] = child[assoc_id_key];
        ret.push(h);
      }
    });
    return ret;
  };

  updateEvent = (send_invitations_on_update) => {
    let {
      id,
      summary,
      description,
      start_time,
      end_time,
      status,
      rrule,
      meeting_number,
      meeting_link,
      created_by,
      active,
      invitees,
      syl_events,
    } = this.state;

    let body = {
      skip_session_flag: true,
      event: {
        summary: summary,
        description: description,
        start_time: start_time,
        end_time: end_time,
        status: status,
        rrule: rrule,
        meeting_number: meeting_number,
        meeting_link: meeting_link,
        created_by_id: created_by.id,
        active: active,
        users_events_attributes: this.childAttributes(invitees, "user_id"),
        syl_events_attributes: this.childAttributes(syl_events, "syllabus_id"),
      },
    };
    const is_new = id === "new" || id === null;
    const event_id = is_new ? "" : this.state.id;
    const url = api_base + "events/" + event_id;
    const reqOptions = {
      method: is_new ? "POST" : "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
      body: JSON.stringify(body),
    };
    this.api_call(url, reqOptions)
      .then((data) => {
        LogIf("debug", "UpdateEvent data from api");
        LogIf("debug", data);
        // let redirect_to_edit = is_new && data['id'];
        data["selecting_invitees"] = false;
        if (!data.errors && data.res_status != "unauthorized") {
          LogIf("debug", "Data success block: " + JSON.stringify(data));
          data["display_notice"] = true;
          data["display_error"] = false;
          data["notice_message"] = "Success: updated event.";
          if (send_invitations_on_update === true) {
            data["send_invitations_on_update"] = true;
          }
          this.setState(data);
        } else {
          LogIf("debug", "Data else block");
          data["display_notice"] = false;
          data["display_error"] = true;
          data["notice_message"] = JSON.stringify(data.errors);
          this.setState(data);
        }
        $(window).scrollTop(0);
      })
      .catch((err) => {
        LogIf("debug", "Caught erorr:" + err);
        let state = this.state;
        state["selecting_invitees"] = false;
        state["display_notice"] = false;
        state["display_error"] = true;
        state["notice_message"] = "Failed to update event.";
        this.setState(state);
        $(window).scrollTop(0);
      });
  };

  /**
   * Calls 'updateEvent' with send_invitations_on_update set to true.
   * This flag will trigger inviteAttendees when the component state
   * updates.
   **/
  updateAndInvite = () => {
    let send_invitations_on_update = true;
    this.updateEvent(send_invitations_on_update);
  };

  /**
   * Called from componentDidUpdate, only when
   * this.state.send_invitations_on_update is true.
   **/
  inviteAttendees = () => {
    this.setState({ send_invitations_on_update: false });
    const event_id = this.state.id;
    const url = api_base + "events/email_attendees";
    const reqOptions = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
      body: JSON.stringify({ id: event_id }),
    };
    this.api_call(url, reqOptions)
      .then((data) => {
        data["selecting_invitees"] = false;
        if (!data.errors && data.res_status != "unauthorized") {
          data["display_notice"] = true;
          data["display_error"] = false;
          data["notice_message"] =
            "Success: emailed " + data["emails_sent"] + " attendees.";
          this.setState(data);
        } else {
          data["display_notice"] = false;
          data["display_error"] = true;
          data["notice_message"] = JSON.stringify(data.errors);
          this.setState(data);
        }
        $(window).scrollTop(0);
        // if (redirect_to_edit) {
        //   window.location = client_base + 'event/' + this.state.id + "?notice=" + data['notice_message'];
        // }
      })
      .catch((err) => {
        let state = this.state;
        state["selecting_invitees"] = false;
        state["display_notice"] = false;
        state["display_error"] = true;
        state["notice_message"] = "Failed to email attendees.";
        this.setState(state);
        $(window).scrollTop(0);
      });
  };

  toggleTrueFalse = (key) => {
    let state = this.state;
    state[key] = !state[key];
    this.setState(state);
  };

  handleTextOrDropdownChange = (key, event) => {
    let state = this.state;
    state[key] = event.target.value;
    this.setState(state);
  };

  handleDateChange = (key, moment) => {
    let state = this.state;
    try {
      let moment_string = moment.format();
      state[key] = moment_string;
      state[key + "_valid"] = true;
      this.setState(state);
    } catch {
      state[key + "_valid"] = false;
      this.setState(state);
    }
  };

  indexByValue = (arr, key, val) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i][key] === val) return i;
    }
    return -1;
  };

  mapIndexByKeysValue = (arr, key) => {
    let valIndexPairs = arr.map((obj, i) => [obj[key], i]);
    return Object.fromEntries(valIndexPairs);
  };

  bulkAddInvitees = () => {
    let { invitees, users } = this.state;
    const inviteIndexMap = this.mapIndexByKeysValue(invitees, "user_id");
    for (let user of users) {
      if (user[MATCH_KEY]) {
        user[ADDED_KEY] = true;
        let inviteIndex = inviteIndexMap[user.id];
        if (inviteIndex > -1) {
          delete invitees[inviteIndex][DESTROY_KEY];
        } else {
          invitees.push({ user_id: user.id, email: user.email });
        }
      }
    }
    this.setState({ invitees: invitees, users: users });
  };

  /**
   * @param addIndex Int index of record in this.state.users.
   * Changes two arrays in state.
   * In this.state.invitees:
   *   - deletes the '_destroy' property for the user's invite,
   *     if an entry for the user exists.
   * In this.state.users:
   *   - user['invited'] = true
   **/
  handleAddInvitee = (addIndex) => {
    let { invitees, users } = this.state;
    let user = users[addIndex];
    user[ADDED_KEY] = true;
    let inviteIndex = this.indexByValue(invitees, "user_id", user.id);
    if (inviteIndex > -1) {
      delete invitees[inviteIndex][DESTROY_KEY];
    } else {
      invitees.push({ user_id: user.id, email: user.email });
    }
    this.setState({ invitees: invitees, users: users });
  };

  /**removeIndex = index of record in this.state.invitees **/
  handleRemoveInvitee = (removeIndex) => {
    let { invitees, users } = this.state;
    invitees[removeIndex][DESTROY_KEY] = DESTROY_VAL;
    let usersIndex = this.indexByValue(
      users,
      "id",
      invitees[removeIndex]["user_id"]
    );
    if (usersIndex > -1) {
      delete users[usersIndex][ADDED_KEY];
    }
    this.setState({ invitees: invitees, users: users });
  };

  handleAddSyl = () => {
    let { syl_events, syllabi_selection, syllabi } = this.state;
    let sylEventIndex = this.indexByValue(
      syl_events,
      "syllabus_id",
      syllabi_selection
    );
    let sylIndex = this.indexByValue(
      syllabi,
      "id",
      parseInt(syllabi_selection)
    );
    console.log("selection", syllabi_selection);
    console.log("sylIndex", sylIndex);
    console.log(syllabi[sylIndex]);
    if (sylEventIndex > -1) {
      delete syl_events[sylEventIndex][DESTROY_KEY];
    } else {
      syl_events.push({
        syllabus_id: syllabi_selection,
        course_code: syllabi[sylIndex]["course_code_a"].replaceAll(",", ""),
        course_name: syllabi[sylIndex]["course_name"],
      });
    }
    this.setState({ syl_events: syl_events });
  };

  /**removeIndex = index of record in this.state.syl_events **/
  handleRemoveSyl = (removeIndex) => {
    let { syl_events, syllabi } = this.state;
    syl_events[removeIndex][DESTROY_KEY] = DESTROY_VAL;
    let syllabiIndex = this.indexByValue(
      syllabi,
      "id",
      syl_events[removeIndex]["syllabus_id"]
    );
    if (syllabiIndex > -1) {
      // let returnSyl = syllabi[syllabiIndex];
      delete syllabi[syllabiIndex][ADDED_KEY];
    }
    this.setState({ syl_events: syl_events, syllabi: syllabi });
  };

  api_call = (url, reqOptions) => {
    return ApiCall(url, reqOptions, this);
  };

  render() {
    let {
      id,
      summary,
      description,
      start_time,
      start_time_valid,
      end_time,
      end_time_valid,
      status,
      // rrule,
      meeting_number,
      meeting_link,
      created_by,
      permissions,
      // active,
      invitees,
      syl_events,
      syllabi_selection,
      syllabi,
      users,
      universities,
      universities_selection,
      selecting_invitees,
      data_ready,
      notice_message,
      display_notice,
      display_error,
    } = this.state;

    const is_new = id === "new" || id === null;
    const page_title = is_new ? "Create Event" : "Edit Event";
    const can_update = is_new ? permissions["create"] : permissions["update"];

    const notice =
      display_error || display_notice ? (
        <div
          role="alert"
          className={
            "card inner-buffer " +
            (display_error ? "alert alert-danger" : "alert alert-success")
          }
        >
          {notice_message}
        </div>
      ) : (
        ""
      );

    const created_by_smalltext =
      !is_new && data_ready ? (
        <small className="text-muted">
          Event created by {created_by["full_name"]}
        </small>
      ) : null;
    const sylEventIds = syl_events.map((ev) => {
      return ev[DESTROY_KEY] === 1 ? null : ev.syllabus_id.toString();
    });

    const inviteableList = selecting_invitees ? (
      <InviteableList
        invitees={invitees}
        inviteables={users}
        syllabi={syllabi}
        sylEventIds={sylEventIds}
        syllabiSelection={syllabi_selection}
        universities={universities}
        universitiesSelection={universities_selection}
        addedKey={ADDED_KEY}
        matchKey={MATCH_KEY}
        bulkAddInvitees={this.bulkAddInvitees}
        fetchUsers={this.fetchUsers}
        handleAddSyl={this.handleAddSyl}
        handleDropdownChange={this.handleTextOrDropdownChange}
        handleInvite={this.handleAddInvitee}
        toggleTrueFalse={this.toggleTrueFalse}
      />
    ) : (
      ""
    );

    const saveBtn = can_update ? (
      <button
        className="btn btn-primary col-2 mt-4"
        type="submit"
        onClick={this.updateEvent}
      >
        Save
      </button>
    ) : (
      ""
    );

    const emailBtn = can_update ? (
      <button
        className="btn btn-primary mt-4 ml-1"
        type="submit"
        onClick={this.updateAndInvite}
      >
        Save and Email Invitees
        {status === EVENT_STATUS_RESCHEDULED ? " (Updated Schedule)" : ""}
      </button>
    ) : (
      ""
    );

    return data_ready ? (
      <div className="container">
        {notice}
        <h1>
          <a className="text-decoration-none" href={"../events"}>
            ←
          </a>
        </h1>
        <h1>{page_title}</h1>
        <div className="d-flex flex-row">
          {inviteableList}
          <div className="card align-self-start inner-buffer w-50">
            {created_by_smalltext}
            <TextInput
              valText={summary}
              editMode={can_update}
              fieldName="summary"
              labelText="Summary:"
              handleChange={this.handleTextOrDropdownChange}
              textBox={true}
              maxLength={"300"}
              required={true}
            />

            <TextInput
              valText={meeting_number}
              editMode={can_update}
              fieldName="meeting_number"
              labelText="Mtg #:"
              handleChange={this.handleTextOrDropdownChange}
              maxLength={"75"}
            />

            <Datepicker
              initialValue={new Date(start_time)}
              currentValueValid={start_time_valid}
              label="Start Time"
              editMode={can_update}
              handleChange={this.handleDateChange}
              stateKey="start_time"
              required={true}
            />

            <Datepicker
              initialValue={end_time ? new Date(end_time) : null}
              currentValueValid={end_time_valid}
              label="End Time"
              editMode={can_update}
              handleChange={this.handleDateChange}
              stateKey="end_time"
              required={true}
            />

            <TextInput
              valText={description}
              editMode={can_update}
              fieldName="description"
              labelText="Description:"
              handleChange={this.handleTextOrDropdownChange}
              textBox={true}
              maxLength={"3000"}
            />

            <TextInput
              valText={meeting_link}
              editMode={can_update}
              fieldName="meeting_link"
              labelText="Meeting Link:"
              handleChange={this.handleTextOrDropdownChange}
              textBox={true}
              maxLength={"3000"}
            />

            <Invitees
              invitees={invitees}
              editMode={can_update}
              removeInvitee={this.handleRemoveInvitee}
              toggleTrueFalse={this.toggleTrueFalse}
              selectingInvitees={selecting_invitees}
            />

            <EventSyllabi
              sylEvents={syl_events}
              editMode={can_update}
              removeSyl={this.handleRemoveSyl}
              toggleTrueFalse={this.toggleTrueFalse}
              selectingInvitees={selecting_invitees}
            />

            <div
              className="submit-btn-bar"
              role="toolbar"
              aria-label="Save/submit options button group"
            >
              {saveBtn}
              {emailBtn}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div className="spinner"></div>
    );
  }
}
